module.exports = __webpack_public_path__ + "static/media/Standing_Instruction.2b7da14b.svg";